import axios from "axios";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

export const getBundleCourses = async () => {
  try {
    const response = await axios.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/bundles`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};